module.exports = __webpack_public_path__ + "static/img/foodie-logo.69bdd8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/foodie-logo.png
// module id = nUo8
// module chunks = 1